import { translate } from '../i18n'
import { StringValidator } from './StringValidator'

export class RegexValidator extends StringValidator {
    regexp: RegExp
    message: string

    constructor(regexp: RegExp, message: string) {
        super()
        this.regexp = regexp
        this.message = message
    }

    isValidString = (value: string) => {
        return this.regexp.test(value)
    }

    getMessage = () => translate(this.message) as string
}
